import request from '@/utils/request'

// 查询单独配置列表
export function listConfig(query) {
  return request({
    url: '/config/config/list',
    method: 'get',
    params: query
  })
}

// 查询单独配置详细
export function getConfig(id) {
  return request({
    url: '/config/config/' + id,
    method: 'get'
  })
}

// 新增单独配置
export function addConfig(data) {
  return request({
    url: '/config/config',
    method: 'post',
    data: data
  })
}

// 修改单独配置
export function updateConfig(data) {
  return request({
    url: '/config/config',
    method: 'put',
    data: data
  })
}

// 删除单独配置
export function delConfig(id) {
  return request({
    url: '/config/config/' + id,
    method: 'delete'
  })
}
